import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FieldRepProfile } from "components/Homeowner/FieldReps";
import { ASSIGNMENT_MODE_INSURANCE } from "components/Assignment";
import { getInspectorDetails, getAssignedCases } from "actions/assignment";
import { getStateList } from "actions/appraiser";
import { getUser, clearInternetUser } from "actions/user";
import { updateFieldRep, getAllTeamLeaders } from "actions/homeowner/fieldReps";
import { updateHeader, clearHeader } from "actions/layout";
import { getNewSearchResults } from "actions/search";
import responseHandler from "responseHandler";
import { 
    HR_INFO_EDIT,
    FIELD_REP_PROFILE_DESIGNATIONS_EDIT, 
    FIELD_REP_PROFILE_DESIGNATIONS_VIEW, 
    EMPLOYEENOTES_VIEW, 
    MANAGEMENT_CALENDAR_EDIT, 
    ALLOWEDITDATEFORFRTIMELOG,
    FIELD_REP_CAN_BE_ASSIGNED_CASES_EDIT,
    FIELD_REP_DISABLE_AUTO_ASSIGN_EDIT,
    EMPLOYEE_COURSE_VIEW,
    FIELDREPPROFILE_EDIT,
} from "typeConstants/rights";
import { userHasRight } from "selectors/rights";

const mapStateToProps = (state) => ({
    isFetching: state.assignment.isFetchingInspectorDetails,
    fieldRep: state.assignment.inspectorDetails,
    isFetchingInternetUser: state.user.isFetchingInternetUser,
    internetUser: state.user.internetUser,
    isFetchingAssignedCases: state.assignment.isFetchingAssignedCases,
    assignedCases: state.assignment.assignedCases,
    stateList: state.appraiser.stateList,
    isFetchingAllTeamLeaders: state.fieldRep.isFetchingAllTeamLeaders,
    allTeamLeaders: state.fieldRep.allTeamLeaders,
    canEditHrInfo: userHasRight(HR_INFO_EDIT)(state),
    canEditFrDesignations: userHasRight(FIELD_REP_PROFILE_DESIGNATIONS_EDIT)(state),
    canViewFrDesignations: userHasRight(FIELD_REP_PROFILE_DESIGNATIONS_VIEW)(state),
    canViewNotes: userHasRight(EMPLOYEENOTES_VIEW)(state),
    canEditCalendarAsManager: userHasRight(MANAGEMENT_CALENDAR_EDIT)(state),
    canEditAdminTimeLog: userHasRight(ALLOWEDITDATEFORFRTIMELOG)(state),
    canEditCanBeAssignedCases: userHasRight(FIELD_REP_CAN_BE_ASSIGNED_CASES_EDIT)(state),
    canDisableAutoAssign: userHasRight(FIELD_REP_DISABLE_AUTO_ASSIGN_EDIT)(state),
    canViewEmployeeCourses: userHasRight(EMPLOYEE_COURSE_VIEW)(state),
    rights: state.user.profile.rights,
    canEditProfile: userHasRight(FIELDREPPROFILE_EDIT)(state),
});

const mapDispatchToProps = (dispatch) => ({
    getInspectorDetails(frNumber) {
        dispatch(getInspectorDetails(ASSIGNMENT_MODE_INSURANCE, frNumber));
    },
    getUser(id) {
        dispatch(getUser(id));
    },
    clearInternetUser() {
        dispatch(clearInternetUser());
    },
    getAssignedCases(frNumber) {
        dispatch(getAssignedCases(ASSIGNMENT_MODE_INSURANCE, frNumber));
    },
    getStateList() {
        dispatch(getStateList());
    },
    updateFieldRep(frNumber, keyValues, callback) {
        dispatch(updateFieldRep(frNumber, keyValues, callback));
    },
    getAllTeamLeaders() {
        dispatch(getAllTeamLeaders());
    },
    updateHeader(headerDefinitions) {
        dispatch(updateHeader(headerDefinitions));
    },
    clearHeader() {
        dispatch(clearHeader());
    },
    getNewSearchResults(searchTerm) {
        dispatch(getNewSearchResults(searchTerm));
    },
    makeToast(text, type) {
        responseHandler.customToast(text, type, dispatch);
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FieldRepProfile));
